/** @type {Styles} */
export const styles = {
  animation: {
    height: 32,
    width: 32,
  },
  buttonLoaderAnimation: {
    height: 24,
    width: 24,
  },
  label: {
    marginTop: 1,
    textAlign: 'center',
  },
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
}
